import client from './client';

export interface LeaderboardItem {
  rank: number;
  address: string;
  score: string;
  highlight: boolean;
}

export interface GetLeaderboardResponse {
  myRank: number;
  myScore: string;
  total: number;
  list: LeaderboardItem[];
}

export const getLeaderboard = async (page: number = 1, pageSize: number = 50): Promise<GetLeaderboardResponse> => {
  const response = await client.get('/leaderboard/tianshidian', {
    params: {
      page,
      pageSize,
    },
  });
  return response.data.data;
};
